import { Cloudinary } from '@cloudinary/url-gen';
import { Delivery } from '@cloudinary/url-gen/actions';
import { fill, fit } from '@cloudinary/url-gen/actions/resize';

export const myCld = new Cloudinary({
  cloud: {
    cloudName: 'wherewego',
  },
  url: {
    secure: true,
  },
});

const getPublicIDFromURL = (url = '') => {
  const urlComponents = url?.split('/');
  const publicId = `${urlComponents[urlComponents.length - 2]}/${
    urlComponents[urlComponents.length - 1]
  }`
    .replace('.jpg', '')
    .replace('.png', '')
    .replace('.jpeg', '');
  return publicId;
};
const getResizedImageURL = (
  publicId: string,
  width: number,
  height: number,
  fitImage?: boolean,
): string => {
  const img = myCld.image(publicId);
  if (fitImage) {
    img.resize(fit(width, height));
  } else {
    img.resize(fill(width, height));
  }
  img.delivery(Delivery.format('jpg'));
  img.quality('70');
  const url = img.toURL();
  return url;
};

export { getPublicIDFromURL, getResizedImageURL };
